function serialize(form) {

  // Setup our serialized data
  var serialized = [];

  // Loop through each field in the form
  for (var i = 0; i < form.elements.length; i++) {

    var field = form.elements[i];

    // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
    if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;

    // If a multi-select, get all selections
    if (field.type === 'select-multiple') {
      for (var n = 0; n < field.options.length; n++) {
        if (!field.options[n].selected) continue;
        serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[n].value));
      }
    }

    // Convert field data to a query string
    else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
      serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
    }
  }

  return serialized.join('&');

};

function validate(field) {
  const parent = field.closest('.input-field,.radio-field,.checkbox-field');
  const fieldGroup = field.closest('.field-group');

  if (!parent || !fieldGroup) return;

  if (field.validity.valid) {
    parent.classList.add('valid');
    parent.classList.remove('invalid');
    fieldGroup.classList.add('valid');
    fieldGroup.classList.remove('invalid');

  } else {
    parent.classList.add('invalid');
    parent.classList.remove('valid');
    fieldGroup.classList.add('invalid');
    fieldGroup.classList.remove('valid');
  }
}

function validateField(e) {
  if (e.target.tagName !== 'INPUT') return;
  validate(e.target);
}

function submitHandler(e) {
  e.preventDefault();

  const form = e.target;

  let valid = true;

  for (const field of form.elements) {
    if (field.tagName !== 'BUTTON' && field.type !== 'hidden') {
      validate(field);
    }

    valid = valid && field.validity.valid;
  }

  if (!valid) {
    form.querySelector('.invalid').scrollIntoView({ behavior: 'smooth' });
    return;
  }

  const serialized = serialize(form);
  form.querySelector('button[type=submit]').classList.add('loading');
  fetch(form.action, {
    method: form.method,
    body: serialized,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(res => {
    if (!res.ok) {
      throw new Error('Not ok response');
    }
  }).then(() => {
    form.querySelector('button[type="submit"]').classList.remove('loading');
    form.querySelector('button[type="submit"]').style.display = 'none';
    document.querySelector('.register-form--thank-you').style.display = '';
    form.style.display = 'none';
    window.scroll(0,0);
  })
  .catch(err => {
    console.error(err);
    form.querySelector('button[type="submit"]').classList.remove('loading');
    form.querySelector('.register-form--submit-error').style.display = '';
  });
}

export default function RegisterForm() {
  const form = document.querySelector('.register-form');
  if (!form) return;

  let i = 1;

  form.querySelectorAll('.hidden').forEach(x => x.style.display = 'none');

  form.querySelector('.add-trainer button').addEventListener('click', () => {
    if (i > 3) {
      return;
    }
    form.querySelector('.trainer-' + ++i).style.display = 'block';

    if (i == 3)
      form.querySelector('.add-trainer').style.display = 'none';
  });

  form.addEventListener('focusout', validateField);
  form.addEventListener('input', validateField);

  form.addEventListener('focus', (e) => {
    const parent = e.target.closest('.input-field');
    parent.classList.remove('invalid');
  });

  const intCheckbox = form.querySelector('input[name=international]');

  if (intCheckbox) {
    intCheckbox.addEventListener('change', (e) => {
      const countryInput = form.querySelector('input[name=country]');
      if (e.target.checked) {
        countryInput.required = true;
        countryInput.closest('.input-field').style.display = '';
        return;
      }

      countryInput.required = false;
      countryInput.closest('.input-field').style.display = 'none';

    });
  }

  form.addEventListener('submit', submitHandler);
};
